export const SERVER_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://production.erg.zone'
    : process.env.REACT_APP_SERVER_URL || 'https://staging.erg.zone';

export const COMP_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://comp.erg.zone'
    : process.env.REACT_APP_SERVER_URL || 'https://staging.erg.zone';

export const EMBED_ORIGIN =
  process.env.NODE_ENV === 'production'
    ? 'https://embed.erg.zone'
    : process.env.REACT_APP_EMBED_ORIGIN || 'http://embed.zone.local:4000';
